import { GroupsApi, useAPIQuery } from "melco-shared-logic";

export const useMachineGroup = (machineGroupId: string | undefined) => {
  return useAPIQuery(
    GroupsApi,
    ["machineGroup", machineGroupId],
    async (api) => {
      if (machineGroupId == null || machineGroupId == "new") {
        return;
      }

      return await api.statisticsGroupsGetById({ id: machineGroupId });
    }
  );
};
